import { FormSection } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { MedicalFiles } from './MedicalFiles';
import { MedicalCenter } from './MedicalCenter';
import { TreatmentsAndTests } from './TreatmentsAndTests';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';

export const FifthSectionNew = () => {
  return (
    <FormSectionWrapper>
      <FormSection
        grouped
        id={Dictionary[DICTIONARY.CASE_DETAILS].fifthSectionTitle}
      >
        <MedicalFiles />
        <TreatmentsAndTests />
        <MedicalCenter />
      </FormSection>
    </FormSectionWrapper>
  );
};
